import { isProCodeComponentType } from './isProCodeComponentType';

/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isLowCodeComponentType(desc) {
  return !isProCodeComponentType(desc);
}